/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useState, useContext } from "react"
import TopHeader from "../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import moment from "moment"
import { dataService } from "../../services/data.services"
import { useParams, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import {useDispatch, useSelector} from 'react-redux'
import { useLazyGetAssociatedOrganizationsQuery, useViewProviderQuery,useLazyGetAssociatedPatientsQuery } from "../../features/providerSlice"
import CustomOverLay from "../../components/CustomOverLay"
import GlobalContext from "../../components/Context/GloablContext"
import ViewAssociatedOrganizationListing from "./Components/ProviderOrganizationAssocaition/ViewAssociatedOrganizationListing"
import ViewAssociatedPatientListing from "./Components/ProviderOrganizationAssocaition/ViewAssociatedPatientListing"
import { handleEditMessageSent } from "../../redux/systemConfigSlice"
import HelpGuideModal from "../../components/HelpGuideModal"
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import OtpPreferenceList from "../../components/OtpPreferenceList/OtpPreferenceList"
import { resetProviderSearch } from "../../redux/providerSearchSlice"
import formatMobileNumber from "../../CommonMethods/FormatMobileNumber"

export default function ViewProvider(provider_userId) {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const { isSideBar,editSocket,sendMessageToStartEditing,setToastErrorMessage,setIsAdvancedSearchOpen } = useContext(GlobalContext)
    const location = useLocation();
    const [providerInfo, setProviderInfo] = useState("");
    const viewId=useSelector(state=>state?.systemConfigData?.viewToUser)
    const dispatch = useDispatch()

    const { id, user_id } = useParams()
    const { data, isFetching, status } = useViewProviderQuery(provider_userId.isOrganization===undefined?id:provider_userId.provider_userId,{refetchOnMountOrArgChange: true})

    const [trigger, result, lastPromiseinfo] = useLazyGetAssociatedOrganizationsQuery()

    const [patientTrigger,patientResult] = useLazyGetAssociatedPatientsQuery()

    const [queryParams, setQueryParams] = useState(`?page_number=1&limit=15&provider_id=${data!== undefined && data?.user_id}`)
    const [patientQueryParams, setPatientQueryParams] = useState(`?page_number=1&limit=15&user_id=${data!== undefined && data?.user_id}`)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
        
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
     useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-view-providers');
        } else {
            setQueryParamsadmin('type=admin-view-providers');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    useEffect(() => {
        trigger(new URLSearchParams(queryParams)?.toString())
    }, [queryParams])

    useEffect(() => {
        patientTrigger(new URLSearchParams(patientQueryParams)?.toString())
    }, [patientQueryParams])



    useEffect(() => {
        if (data !== undefined) {
            setProviderInfo(data)
        }
        setQueryParams((prevParams) => `?page_number=1&limit=15&provider_id=${data!== undefined && data?.user_id}`);
        setPatientQueryParams((prev)=>`?page_number=1&limit=15&user_id=${data!== undefined && data?.user_id}`)
    }, [data])




const handleNavigationToEditPage = () => {
    
        if(!messageSent){
            sendMessageToStartEditing(providerInfo?.user_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    navigate(`/manage-provider/add-provider/${id}`, {state:[location.state,true,id], provider_id:providerInfo?.user_id})
                    dispatch(resetProviderSearch()),
                    setIsAdvancedSearchOpen(false) 
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this provider`)
                    }
                }
            }    
        }
    
  
}
const handleGobackFn = () =>{
    let params = Object.fromEntries(searchParams);
    params['view']!==null && delete params['view']
    setSearchParams({ ...params})
}


    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={provider_userId.isOrganization===undefined?"Manage Provider":"Manage Organizations"} />
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching && status !== "fulfilled" ? <CustomOverLay Active text="Loading Provider Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : <>

                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center mb-5'>
                                    {provider_userId.isOrganization===undefined?<>
                                        <Link to="/manage-provider" state={Array.isArray(location.state) ? '' : location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">Manage Provider</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                        <h1 className="text-sm font-normal text-[#008586]">View Provider</h1>
                                        {
                userType !=='super-admin' &&
                <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            }
               
                                    </>:<>
                                        <Link to="/manage-organizations">
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Organizations</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        
                                        {viewId!==""&&<>
                                            <Link to={`/manage-organizations/${viewId}`}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                                            </Link>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        </>} 
                                        <button onClick={handleGobackFn}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Providers</h1>
                                        </button>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">View Provider</h1>
                                        {
                userType !=='super-admin' &&
                <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            }
               
                                    </>}
                                </div>

                                <div className="flex items-center justify-between">
                                    {provider_userId.isOrganization===undefined?<Link to={'/manage-provider'} state={Array.isArray(location.state) ? '' : location.state} className='flex items-center min-w-max z-[10]'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </Link>:<button onClick={handleGobackFn} className='flex items-center min-w-max z-10'> 
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </button>}
                                    {/* <h1 className='text-xl font-normal text-[#000000] text-center'>
                                        {providerInfo.user_type==="admin-user" ? 'View Admin User': 'Corporate User'}
                                    </h1> */}
                                    <h1 className='text-xl font-normal text-[#000000] w-full text-center xl:ml-[-145px] ml-[-53px]'> View Provider</h1>
                                    {provider_userId.isOrganization===undefined ? 
                                        <div className="xl:hidden block mr-5">
                                            <button data-testid="edit-provider" onClick={() => { handleNavigationToEditPage()}} id="edit" type='button' className={'min-w-max px-4 py-2.5 border border-[#972E4C] h-fit rounded-[16px] flex items-center'}>
                                                <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                                <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                            </button>
                                        </div>:""
                                    }

                                </div>
                                <div className="pt-2 pb-2 border-b border-[#C5C9DA] xl:flex-nowrap flex-wrap w-full flex justify-between items-center">
                                    <div className="flex items-center">
                                        <p className="text-xl font-semibold text-[#000000]">{providerInfo?.first_name} {providerInfo?.last_name}</p>
                                        <p className="text-sm font-normal text-[#000000] px-4">{providerInfo?.user_id}</p>
                                        {providerInfo?.status == 'inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> :
                                        <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                        }
                                    </div>
                                    {provider_userId.isOrganization===undefined ? 
                                        <div className="flex xl:my-0 my-3 items-center">
                                            <button type="button" id="view-activity-log"
                                                onClick={() => { navigate('/manage-provider/activity_history', { state: [providerInfo.user_name, true, id] }),
                                                dispatch(resetProviderSearch()),
                                                setIsAdvancedSearchOpen(false) 
                                                }}
                                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                                rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E]
                                                    focus:bg-[#863B50] disabled:bg-[#777C88] mr-4 ${userType==='corporate-user'?'hidden':''}`}>
                                                View Activity Log
                                            </button>
                                            <div className="xl:block hidden">
                                                <button data-testid="edit-provider" onClick={() => { handleNavigationToEditPage()}} id="edit" type='button' className={'min-w-max px-4 py-2.5 border border-[#972E4C] h-fit rounded-[16px] flex items-center'}>
                                                    <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                                    <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                </button>
                                            </div>
                                        </div>:""
                                    }
                                </div>
                                <div className="h-customh6 overflow-auto scrollBar-hidden">
                                    <div className="mt-[35px] bg-[#E7EAF4] rounded-sm px-5 pt-[30px] pb-[22px]">
                                        <div className="flex -mx-1 flex-wrap">
                                            <div className="w-1/4 px-1 mb-5">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Username</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {providerInfo?.user_name}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-5">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {providerInfo?.email_address !== "" ? providerInfo?.email_address : '-'}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-5">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {providerInfo?.mobile_number !== "" ? providerInfo.mob_no_country_code + " " + formatMobileNumber(providerInfo?.mobile_number) : "-"}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-5">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {providerInfo.main_no_country_code} {formatMobileNumber(providerInfo.main_number)}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-5">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">NPI Number</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {providerInfo?.npi_number !== "" ? providerInfo?.npi_number:'-'}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-5">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Provider Credentials</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {providerInfo?.provider_credential !== "" ? providerInfo?.provider_credential:'-'}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-5">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Block SMS Alert</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        <span className={`inline-flex items-center justify-start bg-[#E7EAF4] text-[#000000] pl-[6px] pr-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                                            {(data?.block_sms ?? data?.userDetails?.block_sms) === true ? "ON" : "OFF"}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-5">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Block Email Alert</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        <span className={`inline-flex items-center justify-start bg-[#E7EAF4] text-[#000000] pl-[6px] pr-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                                            {(data?.block_email ?? data?.userDetails?.block_email) === true ? "ON" : "OFF"}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-full px-1">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Address</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {providerInfo?.address !== "" ?providerInfo?.address:'-'}</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="bg-[#E7EAF4] mt-[22px] rounded-sm py-[5px] pl-5 2xl:pr-[46px] pr-5">
                                        <h1 className="text-[16px] pt-6 font-semibold text-[#000000]">Billing Contact</h1>
                                        <div className=" bg-[#E7EAF4] relative  rounded-sm  pt-[12px] pb-[22px]">
                                            <div className="flex  -mx-1 flex-wrap">
                                                <div className="w-1/3 px-1 mb-[30px]">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Contact Name</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {providerInfo?.billing_contact?.contact_name !== "" ? providerInfo?.billing_contact?.contact_name : '-'}</p>

                                                    </div>
                                                </div>

                                                <div className="w-1/3 px-1 mb-[30px]">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Phone Number</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {providerInfo?.billing_contact?.billing_mobile_number !== "" ? providerInfo.billing_contact?.billing_mobile_no_country_code + " " + formatMobileNumber(providerInfo?.billing_contact?.billing_mobile_number) : "-"}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-1 mb-[30px]">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Fax</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {providerInfo?.billing_contact?.fax !== "" ? providerInfo.billing_contact?.fax_country_code + " " + formatMobileNumber(providerInfo?.billing_contact?.fax) : "-"}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-1">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {providerInfo?.billing_contact?.billing_email_address !== "" ? providerInfo?.billing_contact?.billing_email_address : '-'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="absolute top-0 right-0">
                                                <img src="/images/viewprovider.png" alt="viewprovider" />
                                            </div>
                                        </div>
                                    </div>
                                    <OtpPreferenceList
                                        username={providerInfo?.user_name}

                                     />
                                    
                                    <ViewAssociatedOrganizationListing
                                        providerInfo={providerInfo}
                                        provider_id={providerInfo.user_id}
                                        trigger={trigger}
                                        result={result}
                                        setQueryParams={setQueryParams}
                                        queryParams={queryParams}
                                    />
                                    <ViewAssociatedPatientListing
                                        providerInfo={providerInfo}
                                        provider_id={providerInfo.user_id}
                                        trigger={patientTrigger}
                                        result={patientResult}
                                        setPatientQueryParams={setPatientQueryParams}
                                        patientQueryParams={patientQueryParams}
                                    />
                                </div>
                                
                            </div>
                            
                        </motion.div>
                        
                    </div>
                </>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
               
            </div>
        </>
    )
}